import { useAuth } from '@/shared/providers/AuthContext';

export type ClinicContextValue = {
  tenant: string;
  clinicNumber: string;
};

export const getStoredClinicContext = (): ClinicContextValue | null => {
  try {
    const raw = localStorage.getItem('auth_clinic');
    if (!raw) return null;

    const clinic = JSON.parse(raw);
    const tenant = clinic?.site_type;
    const clinicNumber = clinic?.clinic_number;

    if (!tenant || !clinicNumber) return null;

    return { tenant, clinicNumber };
  } catch {
    return null;
  }
};

export const useClinicContext = (): ClinicContextValue => {
  const { clinic } = useAuth();

  const tenant = clinic?.site_type;
  const clinicNumber = clinic?.clinic_number;

  if (!tenant || !clinicNumber) {
    throw new Error('Tenant (site_type) or clinic_number is not available');
  }

  return { tenant, clinicNumber };
};
